import "./NewsImagePreview.scss";
import ImagePreview from "@/components/Common/ImagePreview/ImagePreview.vue";
import { createError } from "@/helpers/newsHelper";

export default {
  name: "NewsImagePreview",
  extends: ImagePreview,
  data() {
    return {
      mainGreen: "#97bd0f",
      mainRed: "#c55c52",
      mainGray: "#7a7a7a"
    };
  },
  props: ["newsMediaChannels", "disabled"],
  methods: {
    createError,
    imgFilename(file) {
      return file?.url?.split("/").reverse()[0];
    },
    //remove or add publication-channel
    checkFileSizes(file) {
      if (!this.showImageAspectRatioButtons) {
        return !file?.image_sizes?.["16:9"];
      }
      if (!file?.image_sizes) return true;
      if (!file.image_sizes["16:9"]) return true;
      if (!file.image_sizes["3:1"]) return true;
      if (!file.image_sizes["1/1 (Mobil)"]) return true;
    },
    toggleChannel(channelValue) {
      if (this.fileToEdit.channels.includes(channelValue)) {
        this.fileToEdit.channels = this.fileToEdit.channels.filter(item => {
          return item !== channelValue;
        });
        this.fileToEdit.channels.reverse().reverse();
      } else {
        this.fileToEdit.channels.push(channelValue);
      }
    }
  }
};
